module.exports = __webpack_public_path__ + "static/img/20160921-1.627a4b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20160921-1.jpg
// module id = 25yY
// module chunks = 0